var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Poptip',{staticClass:"iv-main-color iv-main-hover-color iv-operate-item iv-pull-left iv-pointer uit-editor-list",attrs:{"confirm":"","title":"确认要删除吗"},on:{"on-ok":function($event){return _vm.expandParent('delete', _vm.item)}}},[_c('span',[_vm._v("删除")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }